import React from "react";
import { Link } from "react-router-dom";
import { useApiData } from "../hooks/useApiData";
import "./PageContent.css";
import "./WebLinkPage.css";

export default function WebLinkPage() {
  // GET /api/links → tbl_links
  // Shape per item: { id, name, image, url, sortOrder, status, date }
  const { data: links, loading } = useApiData("links");
  const { data: leaders } = useApiData("leadership");

  const principal = leaders?.find((l) =>
    String(l.role || "").toLowerCase().match(/principal|dean/)
  );
  const medicalSuperintendent = leaders?.find((l) =>
    String(l.role || "").toLowerCase().includes("medical superintendent")
  );

  const slugify = (str) =>
    String(str || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const renderOfficialMessage = (leader, title) => {
    if (!leader) {
      return null;
    }

    return (
      <div className="official-message-block">
        <div className="official-message-title">{title}</div>

        <div className="official-message-body">
          <div className="official-message-top">
            <div className="official-photo-wrapper">
              <img
                src={leader.img}
                alt={leader.name}
                className="official-photo"
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    leader.name || "Official"
                  )}&background=0b5d7a&color=fff&size=150`;
                }}
              />
            </div>

            <div className="official-message-text">
              <p>{leader.message}</p>
            </div>
          </div>

          <div className="official-name">{leader.name}</div>

          <div className="official-role">{leader.role}</div>

          <div className="official-more-wrapper">
            <Link
              to={`/leadership-message/${slugify(leader.role)}`}
              className="official-more"
            >
              More...
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const renderLinkItem = (item) => (
    <div key={item.id} className="weblink-item">
      <div className="weblink-logo-wrapper">
        <img
          src={item.image}
          alt={item.name}
          className="weblink-logo"
          onError={(e) => {
            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
              item.name || "Link"
            )}&background=0b5d7a&color=fff&size=100`;
          }}
        />
      </div>

      <div className="weblink-info">
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="weblink-name"
        >
          {item.name}
        </a>

        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="weblink-url"
        >
          {item.url}
        </a>
      </div>
    </div>
  );

  const totalCount = links?.length || 0;

  return (
    <main className="content-page-wrapper">
      <div className="content-breadcrumb-wrapper">
        <div className="content-container">
          <div className="content-breadcrumb">
            <Link to="/">
              <i className="fa fa-home"></i>
              Home
            </Link>

            <span className="breadcrumb-arrow">
              <i className="fa fa-angle-right"></i>
            </span>

            <span className="breadcrumb-current">Web Link</span>
          </div>
        </div>
      </div>

      <div className="content-container">
        <div className="content-layout">
          <aside className="content-sidebar">
            <div className="official-info-card">
              <div className="official-info-header">
                <div className="official-info-icon">
                  <i className="fa fa-envelope-o"></i>
                </div>
                <span>MESSAGE FROM</span>
              </div>

              <div className="official-info-body">
                {renderOfficialMessage(principal, "DEAN AND PRINCIPAL")}
                {renderOfficialMessage(
                  medicalSuperintendent,
                  "MEDICAL SUPERINTENDENT"
                )}
              </div>
            </div>
          </aside>

          <section className="content-main-card">
            <h1 className="notice-page-title">Web Link</h1>

            {loading ? (
              <div className="content-loading">
                <div className="content-spinner"></div>
                <p>Loading web links...</p>
              </div>
            ) : totalCount > 0 ? (
              <div className="weblink-grid">
                {links.map((item) => renderLinkItem(item))}
              </div>
            ) : (
              <p className="notice-card-empty">No web links found.</p>
            )}
          </section>
        </div>
      </div>
    </main>
  );
}
